const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_STUDY_LEVEL,
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_EXPERIENCE
} = require('constants/actionTypes.js');

const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHECK_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_STEP1_CONTINUE_WITH_INCOHERENCES,
} = require('mifid/constants/actionTypes');

const changeStudyLevel = (studyLevel) => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_STUDY_LEVEL,
        payload: {
            studyLevel
        }
    });
};

const changeExperience = (experience) => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHANGE_EXPERIENCE,
        payload: {
            experience
        }
    });
}

const checkIncoherences = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP1_CHECK_INCOHERENCES
    });
}

const continueWithIncoherences = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP1_CONTINUE_WITH_INCOHERENCES
    })
}

module.exports = {
    changeStudyLevel,
    changeExperience,
    checkIncoherences,
    continueWithIncoherences
};
